export const getSeverityLabel = (severity) => {
  switch (severity) {
    case 0:
      return "Unknown";
    case 1:
      return "Minor";
    case 2:
      return "Moderate";
    case 3:
      return "Major";
    case 4:
      return "Remediated"
    default:
      return "Unknown";
  }
};

export const severityCode = {
  Unknown: 0,
  Minor: 1,
  Moderate: 2,
  Major: 3,
  Remediated: 4,
};

export const severityColors = {
  Minor: "rgb(210, 217, 0)",
  Moderate: "#ED8C2D",
  Major: "#da1d1a",
  Remediated: "#0AB37D",
};
